import { create } from 'zustand';

const useEmojiDialogStore = create((set, get) => ({
  open: false,
  _promise: null,
  requestEmoji: () => {
    const promise = new Promise((resolve) => {
      set(() => ({ open: true, _promise: { resolve } }));
    });
    return promise;
  },
  setSelectedEmoji: (emoji) => {
    const { _promise } = get();
    if (_promise) {
      _promise.resolve(emoji);
    }
    set(() => ({ open: false, _promise: null }));
  },
}));

export default useEmojiDialogStore;
